var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmokingNo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "No_Smoker",
    "data-name": "No Smoker",
    transform: "translate(-451 -451)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_75",
    "data-name": "Rechteck 75",
    width: 0.994,
    height: 3.408,
    transform: "translate(477.927 469.436)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_651",
    "data-name": "Pfad 651",
    d: "M2305.117,2040.952h1.389v-3.408h-4.8Z",
    transform: "translate(-1829.204 -1568.108)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_652",
    "data-name": "Pfad 652",
    d: "M1020.056,2037.544H1011.2v3.408h12.265Z",
    transform: "translate(-553.689 -1568.108)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_76",
    "data-name": "Rechteck 76",
    width: 0.994,
    height: 3.408,
    transform: "translate(479.489 469.436)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_653",
    "data-name": "Pfad 653",
    d: "M469,451a18,18,0,1,0,18,18A17.927,17.927,0,0,0,469,451Zm5.72,31.545A14.7,14.7,0,0,1,457.5,459.838L478.162,480.5A14.609,14.609,0,0,1,474.72,482.545Zm7.825-7.825a14.609,14.609,0,0,1-2.049,3.441L459.838,457.5h0a14.7,14.7,0,0,1,22.707,17.216Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_654",
    "data-name": "Pfad 654",
    d: "M2229.719,1009.943a4.783,4.783,0,0,0-.6-1.9,4.657,4.657,0,0,0-1.309-1.466,4.253,4.253,0,0,0-1.549-.69,8.5,8.5,0,0,0-1.758-.054,5.242,5.242,0,0,0,.242-.821,3.509,3.509,0,0,0,.054-1.638,3.162,3.162,0,0,0-1.135-1.717,3.635,3.635,0,0,0-2.336-.793.5.5,0,1,0,.014.994,2.642,2.642,0,0,1,1.7.57,2.218,2.218,0,0,1,.8,1.18,2.589,2.589,0,0,1-.06,1.2,4.342,4.342,0,0,1-.486,1.274.5.5,0,0,0,.058.576.508.508,0,0,0,.385.169c1.21,0,2.463-.175,3.509.562a3.64,3.64,0,0,1,1.019,1.147,3.786,3.786,0,0,1,.474,1.486l.036,2.35.993-.015-.036-2.371A.367.367,0,0,0,2229.719,1009.943Z",
    transform: "translate(-1749.267 -543.471)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_655",
    "data-name": "Pfad 655",
    d: "M1919.421,917.584a2.694,2.694,0,0,0-1.927-.988h-3.46a1.371,1.371,0,0,1-.742-.347,1.5,1.5,0,0,1-.418-.932,2.028,2.028,0,0,1,.184-1.162.5.5,0,0,0-.1-.571.5.5,0,0,0-.334-.139,3.422,3.422,0,0,1-.961-.173,2.5,2.5,0,0,1-1.441-.958,2.327,2.327,0,0,1-.122-1.956,1.982,1.982,0,0,1,.835-1.128,1.82,1.82,0,0,1,.959-.243h0a.5.5,0,0,0,.506-.487h0a.5.5,0,0,0-.488-.506h0a2.807,2.807,0,0,0-1.483.381,2.966,2.966,0,0,0-1.267,1.655,3.313,3.313,0,0,0,.219,2.815,3.446,3.446,0,0,0,1.967,1.37,4.371,4.371,0,0,0,.593.153,2.932,2.932,0,0,0-.047,1.1,2.474,2.474,0,0,0,.718,1.51,2.366,2.366,0,0,0,1.335.615.494.494,0,0,0,.057,0h3.448a1.677,1.677,0,0,1,1.185.6,1.529,1.529,0,0,1,.294.7v1.625h.994v-1.661a.5.5,0,0,0,0-.063A2.527,2.527,0,0,0,1919.421,917.584Z",
    transform: "translate(-1441 -451.68)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmokingNo);
export default __webpack_public_path__ + "static/media/smoking-no.5439da7883c0286c57b370806db3c224.svg";
export { ForwardRef as ReactComponent };